"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formatNumber = _interopRequireDefault(require("format-number"));

var _semanticUiReact = require("semantic-ui-react");

var _ucfirst = require("@seafront/ucfirst");

var _moment = _interopRequireDefault(require("../../lib/moment"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _SquaredText = _interopRequireDefault(require("../01_atoms/SquaredText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var formatPrice = function formatPrice(price) {
  return (0, _formatNumber["default"])({
    prefix: '$',
    round: 2,
    padRight: 2
  })(price);
};

var TicketDetailsContent = function TicketDetailsContent(_ref) {
  var _ticketDetails$apiDat;

  var _ref$topRightLabel = _ref.topRightLabel,
      topRightLabel = _ref$topRightLabel === void 0 ? null : _ref$topRightLabel,
      ticketDetails = _ref.ticketDetails,
      _ref$nPassengers = _ref.nPassengers,
      nPassengers = _ref$nPassengers === void 0 ? 1 : _ref$nPassengers,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? 'en' : _ref$locale;
  var departure = (0, _moment["default"])(ticketDetails.departureTime).locale(locale);
  var arrival = (0, _moment["default"])(ticketDetails.arrivalTime).locale(locale); // const rideDuration = moment.duration(arrival.diff(departure));
  // const formattedDuration = `${rideDuration.hours()}h ${rideDuration.minutes()}m`;

  var nDaysAdded = _moment["default"].duration((0, _moment["default"])(arrival.format('YYYY-MM-DD')).diff((0, _moment["default"])(departure.format('YYYY-MM-DD')))).days();

  var d = nDaysAdded ? " (+".concat(nDaysAdded, "d)") : '';
  var dh = departure.format('HH:mm');
  var ah = arrival.format('HH:mm'); // const fp = (nPassengers > 1 ? `${nPassengers} x ` : '') + formatPrice(ticketDetails.grossPrice);

  var dt = (0, _ucfirst.ucfirstEachWord)(ticketDetails.originTerminal.name);
  var at = (0, _ucfirst.ucfirstEachWord)(ticketDetails.destinationTerminal.name);
  var companyLogo = ticketDetails.transporter.logo;
  var companyName = (0, _ucfirst.ucfirstEachWord)(ticketDetails.transporter.name);
  var departureDate = departure.format('LL'); // const HighLight = ({ children }) => <span style={withBoldTitleFont({})}>{children}</span>;
  // const Details = ({ children }) => <span style={withWidgetSubtitleFont({})}>{children}</span>;

  return /*#__PURE__*/_react["default"].createElement("div", null, topRightLabel && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Label, {
    color: topRightLabel.color || undefined,
    style: {
      position: 'absolute',
      top: -1,
      right: -3,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      fontSize: '0.9rem',
      lineHeight: '1.4',
      paddingTop: 5,
      paddingBottom: 5,
      //   {/* attached="top right" */}
      // borderTop: '1px solid rgb(221, 226, 230)',
      marginTop: 0
    }
  }, topRightLabel.content || undefined, "\xA0"), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.9em',
      marginBottom: 10
    }
  }, departureDate), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginRight: 15
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '1rem',
      color: '#3176D4',
      textAlign: 'center'
    }
  }, dh), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      flex: '1',
      borderLeft: 'dashed 2px #909B9D',
      marginTop: 5,
      marginBottom: 5
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '1rem',
      color: '#3176D4',
      textAlign: 'center'
    }
  }, ah, d && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.8em'
    }
  }, d)))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      justifyContent: 'space-between',
      marginRight: 15,
      flex: '1'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", null, dt), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.8em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_SquaredText["default"], {
    style: {
      marginLeft: 0,
      marginTop: 8,
      marginBottom: 8
    }
  }, (ticketDetails === null || ticketDetails === void 0 ? void 0 : ticketDetails.busCategory) || (ticketDetails === null || ticketDetails === void 0 ? void 0 : (_ticketDetails$apiDat = ticketDetails.apiData) === null || _ticketDetails$apiDat === void 0 ? void 0 : _ticketDetails$apiDat.trp_desc))), /*#__PURE__*/_react["default"].createElement("div", null, at, d && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.8em'
    }
  }, "\xA0")))), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '30%',
      textAlign: 'center',
      width: 150
    }
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
    style: {
      height: 40,
      width: 'auto',
      marginBottom: 5
    },
    src: companyLogo,
    size: "mini"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '0.7rem',
      textAlign: 'center'
    }
  }, companyName), d && /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: _Colors.discreetTextColor,
      fontSize: '0.8em'
    }
  }, "\xA0"))));
  /*
   return (
    <table style={{ width: '100%' }}>
      <tr>
        <td>
          <Dot />
        </td>
        <td>
          <HighLight>{dh}</HighLight>
        </td>
        <td>
          <HighLight>{dt}</HighLight>
        </td>
        <td />
      </tr>
      <tr>
        <td>
          <div />
        </td>
        <td>
          {' '}
          <Image src={companyLogo} avatar />
        </td>
        <td>
          <Details>{formattedDuration}</Details>
        </td>
        <td style={{ textAlign: 'right' }}>
          <HighLight>{fp}</HighLight>
        </td>
      </tr>
      <tr>
        <td>
          <Dot />
        </td>
        <td>
          <HighLight>{ah + d}</HighLight>
        </td>
        <td>
          <HighLight>{at}</HighLight>
        </td>
        <td />
      </tr>
    </table>
    );
    */
};

var _default = TicketDetailsContent;
exports["default"] = _default;